declare namespace $ {

	export class $yuf_check_icon2 extends $mol_check_icon {
		icon_disabled( ): boolean
		hint_checked( ): string
		hint_unchecked( ): string
		Icon_checked( ): $mol_icon_eye
		Icon_unchecked( ): $mol_icon_eye_off
	}
	
}

//# sourceMappingURL=check.view.tree.d.ts.map